import { configureStore } from "@reduxjs/toolkit";

import { wordsApi } from "./services/wordsApi";

export default configureStore({
  reducer: {
    [wordsApi.reducerPath]: wordsApi.reducer,
  },
});
